import { debounce } from './debounce';
import { useMemo } from 'react';

export const useDebounce = <T extends (...args: any[]) => any>(
	func: T,
	delay: number,
	...deps: Array<any>
): ThisType<T> & ((...args: Parameters<T>) => Promise<ReturnType<T>>) => {
	return useMemo(() => debounce<T>(func, delay)[0], deps);
};
